import { Component, OnInit } from '@angular/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AbstractBiditComponent } from '../../controls/abstract.bidit.component';

@Component({
  selector: 'app-page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class PageHeaderComponent extends AbstractBiditComponent implements OnInit {

  constructor(private deviceDetectorService: DeviceDetectorService) {
    super(deviceDetectorService);
  }

  ngOnInit(): void {
  }

}
